import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  ref,
} from "vue";

import {
  useI18n,
} from "@/composables/useI18n";

import InfoSnackbar from "@/components/children/InfoSnackbar.vue";

import {
  ErrorDialog,
} from "@/components/dialogs";

import {
  SepaIssuerSettings,
  SepaOtherSettings,
  SepaTerminalSettings,
} from "@/components/settings/children/sepaSettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'SepaSettings',
  props: {
  token: {
    required: true,
    type: String as PropType<string>,
  }
},
  setup(__props) {

const props = __props;

const {
  t
} = useI18n();



const fetchError = ref<any>();
const snackbarStatus = ref('');
const snackbarText = ref<string[]>([]);
const snackbarRef = ref(null);

const onHandleFetchError = ({error}: { error: any }) => {
  fetchError.value = error;
};

const showSnackbar = (
  {
    status = undefined,
    statusText = undefined
  }: {
    status?: string,
    statusText?: string[]
  }
) => {
  snackbarStatus.value = status ? status : 'success';
  snackbarText.value = statusText ? statusText : [t('success')];

  (snackbarRef.value as any).show();
};

const setSnackbarSuccessStatus = () => {
  const statusText = [t('update_successful')];
  const status = 'success';

  showSnackbar({statusText, status});
}

const onHandleErrorDialogCancelOrConfirm = () => {
  fetchError.value = undefined
};

return { __sfc: true,t, props, fetchError, snackbarStatus, snackbarText, snackbarRef, onHandleFetchError, showSnackbar, setSnackbarSuccessStatus, onHandleErrorDialogCancelOrConfirm, InfoSnackbar, ErrorDialog, SepaIssuerSettings, SepaOtherSettings, SepaTerminalSettings }
}

})